
<main>
    <div class="jobs">
        <div class="post-job cursorClass">
            <a (click)="addEditSubEvent('Add')"  *ngIf="userTypeId == 1">
                <i class="ti ti-circle-plus"></i>
                <h4>પેટા કાર્યક્રમ નોંધણી કરો</h4>
            </a>
        </div>
        <h4>પેટા કાર્યક્રમ</h4>
        <hr>
        <div class="filtering">
            <form>
                <input placeholder="શોધો..." type="search" #filter (keyup)="applyFilter($event)" 
                class="form-control" aria-label="Search box">
                <i class="ti ti-search"></i>
            </form>
           
            <a class="ti ti-refresh cursorClass" (click)="getSubEventListData()"></a>
        </div>
         <div> 
            <div class="main-members">
                <a class="member-list-item" *ngFor="let data of getSubEventList">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="goToInvitationAndPresentMember(data)">
                      <span>{{label}}</span>
                    </button>
                    <button mat-menu-item (click)="goToAttendanceScanner(data)" [hidden]="userTypeId != 1">
                        <span>હાજરી ભરો</span>
                      </button>
                      <button mat-menu-item (click)="goToEventDonor(data)" >
                        <span>કાર્યક્રમ દાતાઓ</span>
                      </button>
                      <button mat-menu-item (click)="goToMomentAlbum(data)" >
                        <span> યાદગીરી</span>
                      </button>
                  </mat-menu>
                    <div class="flex1">
                        <h5>{{data.sub_event_name}}</h5>
                        <small>મુખ્ય કાર્યક્રમ : {{data.event_name}}</small><br>
                        <small>તારીખ :  {{data.from_date | date: 'dd/MM/yyyy'}}  થી  {{data.to_date | date: 'dd/MM/yyyy'}}</small>
                    </div>

                    <i class="ti ti-pencil" (click)="addEditSubEvent('Edit',data)"  *ngIf="userTypeId == 1"></i>
                    <!-- <i class="ti ti-trash" (click)="openDialog(data.business_id)"></i> -->
                </a>
            </div>
         </div> 
    </div>
</main>